module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app u-fit-w",
    class: ['is-' + _vm.componentId, _vm.isTouch ? 'is-touch' : '', _vm.isFirstLoading ? 'is-first-loading' : '', _vm.supportClasses],
    attrs: {
      "id": "app"
    },
    on: {
      "touchmove": _vm._onTouchMove
    }
  }, [(_vm.content !== null || _vm.contentPage !== null) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "js-container",
    class: [_vm.componentId === _vm.$root.CONFIG.pages.home.name ? 'u-fit-v u-overflow-h' : 'u-fit-w']
  }, [(_vm.content !== null) ? _c(_vm.componentId, {
    tag: "component",
    staticClass: "js-page",
    attrs: {
      "content-page": _vm.contentPage
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "js-screen-size u-fixed u-pos-tl u-fit-v u-opacity--0 u-pointer-none"
  }), _vm._v(" "), _c('app-transition', {
    attrs: {
      "is-active": _vm.isTransitionActive
    }
  }), _vm._v(" "), (!_vm.isTouch) ? _c('div', {
    staticClass: "js-fake-scroll-container",
    style: ({
      height: _vm.pageHeight + 'px'
    })
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9044942"}!./src/scripts/application/template.html
// module id = 150
// module chunks = 0